var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-item-component",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("div", {
        staticClass: "item-cover",
        style: "background-image: url(" + _vm.img_src + ")"
      }),
      _vm._v(" "),
      _c("div", { staticClass: "textContent" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.sub_title) } }),
        _vm._v(" "),
        _c("div", {
          staticClass: "title",
          domProps: { innerHTML: _vm._s(_vm.title) }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }